/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Player_Add_To_NotepadInputs */

const en_mobile_player_add_to_notepad = /** @type {(inputs: Mobile_Player_Add_To_NotepadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to Notepad`)
};

const es_mobile_player_add_to_notepad = /** @type {(inputs: Mobile_Player_Add_To_NotepadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar al bloc de notas`)
};

/**
* | output |
* | --- |
* | "Add to Notepad" |
*
* @param {Mobile_Player_Add_To_NotepadInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_player_add_to_notepad = /** @type {((inputs?: Mobile_Player_Add_To_NotepadInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Player_Add_To_NotepadInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_player_add_to_notepad(inputs)
	return en_mobile_player_add_to_notepad(inputs)
});